import React, { Component } from 'react';
import * as moment from 'jalali-moment';
import Row1 from './grid/row1';
import Row2 from './grid/row2';
import Row3 from './grid/row3';
import Row4 from './grid/row4';
import Row5 from './grid/row5';
import './index.css';



class PDFInvoice extends Component {
  constructor(props) {
    super(props);
    this.state = {
        
    }
  }


  render() {
    const { pdfInfo } = this.props;
    //console.log('PDFInvoice pdfInfo--------- ', pdfInfo)
    let date = moment().locale('fa').format('YYYY/M/D')
    return (
      <div className='pdf-invoice-component' id='pre-invoice-pdf'>
        <div className='pdf-invoice-container'>
          <div className='pdf-invoice-header-wrapper'>
            <div className='pdf-invoice-header-left display-flex-column-center'>
              <div className='pdf-invoice-serial-number-wrapper display-flex-row-center' style={{marginBottom:'5px'}}>
                <div className='pdf-invoice-serial-number-box' style={{marginRight:'10px',fontSize: '19px', color:'red'}}>{'پیش فاکتور'}</div>
                <div className='pdf-invoice-serial-number-text'>{':شماره سریال' }</div>
              </div>
              <div className='pdf-invoice-serial-number-wrapper display-flex-row-center'>
                <div className='pdf-invoice-serial-number-box'  style={{marginRight:'10px'}}>{date}</div>
                <div className='pdf-invoice-serial-number-text'>{':تاریخ' }</div>
              </div>
            </div>
            <div className='pdf-invoice-header-center'>
              (<p>{'صورت حساب فروش کالا و خدمات'}</p>)
            </div>
            <div className='pdf-invoice-header-right'>
              <img alt='' src={require('../../../assets/images/pdf-logo.png')} />
            </div>
          </div>
          <div className='pdf-invoice-grid-wrapper'>
            <Row1 />
            <Row2 pdfInfo={pdfInfo}/>
            <Row3 pdfInfo={pdfInfo}/>
            <Row4 pdfInfo={pdfInfo}/>
            <Row5 />
          </div>
        </div>
      </div>
    );
  }
}




export default PDFInvoice;
